/* eslint-disable jsx-a11y/label-has-associated-control */
import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'anchor-label',
  styleUrl: 'label.scss',
  shadow: false,
})
export class Label {
  /**
   * Match this with an input id to create a label + input pair.
   * Leave this field empty or unset if the input field is nested inside the label
   */
  @Prop() for: string | undefined | null = null;

  render() {
    return (
      <Host>
        <label htmlFor={this.for || undefined}>
          <slot />
        </label>
      </Host>
    );
  }
}
